import type { ApiImportData } from '@dc-trans/data-layer';
import { generateImportTemplate, type TemplateConfig } from './download';

interface GenerateErrorFeedbackParams {
  uploadResult: ApiImportData;
  excelTemplate?: Omit<TemplateConfig, 'data'>;
}

export const generateErrorFeedback = ({ uploadResult, excelTemplate }: GenerateErrorFeedbackParams): void => {
  if (!uploadResult.errors || uploadResult.errors.length === 0) {
    console.warn('No errors found in upload result');
    return;
  }

  generateImportTemplate({
    name: 'Error Feedback Upload',
    headers: [
      ...(excelTemplate?.headers || []),
      { key: 'error_notes', header: 'Error Notes', width: 40, hideNote: true },
    ],
    referenceData: excelTemplate?.referenceData!,
    data: uploadResult.errors.map(item => {
      const errorData: Record<string, any> = {};
      (excelTemplate?.headers || []).forEach(header => {
        if (header.key) {
          errorData[header.key] = item[header.key as keyof typeof item];
        }
      });
      errorData.error_notes = item.error_notes;
      return errorData;
    }),
  });
};
